import { useState, useEffect } from 'react';

// Default fallback metrics structure
const defaultMetrics = {
  registeredCompanies: 0,
  registeredProfessionals: 0,
  publishedOffers: 0,
  totalApplications: 0,
  breakdown: {
    restaurantProfiles: 0,
    adminCompanyUsers: 0,
    professionalProfiles: 0,
    professionalUsers: 0
  }
};

export const useMetrics = () => {
  const [metrics, setMetrics] = useState(defaultMetrics);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMetrics = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/admin/metrics`);

      if (!response.ok) {
        console.warn('Failed to fetch metrics, using fallback values');
        setMetrics(defaultMetrics);
        return;
      }

      const data = await response.json();

      setMetrics({
        ...defaultMetrics,
        ...data,
        breakdown: {
          ...defaultMetrics.breakdown,
          ...(data.breakdown || {})
        }
      });
    } catch (err) {
      console.warn('Error fetching metrics, using fallback values:', err);
      setMetrics(defaultMetrics);
      setError(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMetrics();
  }, []);

  return { metrics, isLoading, error, refetch: fetchMetrics };
};
